import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [NgIf, Button],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  @Input() visible = false;
  @Output() closeModal = new EventEmitter<void>();

  close() {
    this.visible = false;
    this.closeModal.emit();
  }
}
